import React from 'react'
import Navbar from './Navbar'
import Container from '../Container/Container'

function Header() {
    
  return (
    <Container>
      <Navbar />
    </Container>
  )
}

export default Header